export default "__VITE_ASSET__vscyahvN__"